import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Card from "../../components/ui/Card";
import Input from "../../components/ui/Input";
import Button from "../../components/ui/Button";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [phone, setPhone]   = useState("123456786");
  const [pass,  setPass]    = useState("password");
  const [err,   setErr]     = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setErr("");
    setLoading(true);
    try {
      await login(phone, pass);
      navigate("/");
    } catch (e: any) {
      console.log(e);
      setErr(e?.error || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-5">
      <div className="w-full max-w-sm">
        <div className="text-center mb-7">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-emerald-600 mb-4 text-3xl">
            {/* 🌿 */}
            <img src="/heritage.jpg" width="55" height="40" style={{borderRadius:"7px"}} alt="logo" ></img>
          </div>
          <h1 className="text-2xl font-medium text-white">Heritage Cooperative</h1>
          <p className="text-slate-400 text-sm mt-1">Savings & Loans</p>
        </div>
        <Card>
          <h2 className="text-lg font-medium text-slate-800 mb-5">Sign in</h2>
          {err && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">{err}</div>}
          <Input label="Phone Number" type="tel" value={phone} onChange={setPhone} placeholder="08000000000"/>
          <Input label="Password" type="password" value={pass} onChange={setPass} placeholder="••••••••"/>
          <Button onClick={submit} size="lg" className="w-full justify-center mb-3" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          {/* <div className="flex gap-2 mb-4">
            <button className="flex-1 flex items-center justify-center gap-2 border border-slate-300 rounded-lg py-2 text-sm text-slate-600 hover:bg-slate-50">
              🔵 Google
            </button>
            <button className="flex-1 flex items-center justify-center gap-2 border border-slate-300 rounded-lg py-2 text-sm text-slate-600 hover:bg-slate-50">
              🍎 Apple
            </button>
          </div> */}
          <p className="text-center text-sm text-slate-500">
            Forgot password? <Link to="/resetpassword" className="text-blue-600 font-medium">Reset password</Link>
          </p>
          <p className="text-center text-sm text-slate-500">
            No account? <Link to="/signup" className="text-emerald-600 font-medium">Create one</Link>
          </p>
        </Card>
        {/* <div className="mt-4 p-3 bg-slate-800 rounded-xl text-xs text-slate-400 space-y-1">
          <p className="font-medium text-slate-300">Demo accounts</p>
          <p>👤 Member: demo@coopsave.com</p>
          <p>🛡️ Admin: admin@coopsave.com</p>
          <p>Password: password</p>
        </div> */}
      </div>
    </div>
  );
}
